import { useData } from "../core/hooks/useData";
import { newID } from "../core/utils/unique";
import { createElement } from "./createElement";
import { GroupElement, TextElement, useContainer, usePresenter } from "./types";


export function Group(props: {
	def: GroupElement,
}) {
	const presenter = usePresenter();
	const container = useContainer();
	const data = useData();

	const { def } = props;

	const items: any[] = [];
	if (def.elements) {
		for(let el of def.elements) {
			const item = createElement(el, presenter, data, container);
			if (!item) continue;

			items.push(item);
		}
	}

	let designElements = [];
	if (presenter.designMode) {
		designElements.push(
			<button
				onClick={() => {
					const elementID = newID();
					const newElement = {
						type: "text",
						id: elementID,
						title: elementID,
					} as TextElement;			
					if (!def.elements) def.elements = [];
					def.elements.push(newElement);
					container.refresh();
				}}
			>Add</button>
		);
	}

	return (
		<div className={"group layout-" + def.layout}>
			{designElements.length > 0 ? <div>{designElements}</div> : undefined}
			{items}
		</div>
	);
}